export default "__VITE_ASSET__6792b3d9__"